import React, { useState } from 'react'
import './style.css'
import cotton from '../../images/collaborations/Cotton.png'
import NHM from '../../images/collaborations/NHM.png'
import GMC from '../../images/collaborations/GMC.png'
import transport from '../../images/collaborations/TRANSPORT.png'
import ECI from '../../images/collaborations/ECI.png'
import WWF from '../../images/collaborations/wwf.png'
import Pollution from '../../images/collaborations/Pollution.png'
import RGU from '../../images/collaborations/RGU.png'
import WLFR from '../../images/collaborations/WLFR.png'

const CollaborationItem = ({ collab }) => {
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div className="collaboration-item">
            <div className="collaboration-logo">
                {imageError ? (
                    <div className="logo-placeholder">{collab.name}</div>
                ) : (
                    <img 
                        src={collab.logo} 
                        alt={collab.name}
                        onError={handleImageError}
                    />
                )}
            </div>
            <div className="collaboration-info">
                <h4>{collab.name}</h4>
                <p>{collab.description}</p>
            </div>
        </div>
    );
};

const Collaboration = (props) => {
    const { 
        title = "Our Collaborations",
        subtitle = "Proud to work with leading organizations and institutions",
        collaborations = [
            {
                name: "Cotton University",
                logo: cotton,
                description: "Educational Institution"
            },
            {
                name: "National Health Mission",
                logo: NHM, 
                description: "Ministry of Health & Family Welfare, Government of India"
            },
            {
                name: "Guwahati Medical College",
                logo: GMC,
                description: "Government of Assam"
            },
            {
                name: "Assam State Transport Department Corporation",
                logo: transport,
                description: "Government of Assam"
            },
            {
                name: "Assam State Election Commission",
                logo: ECI,
                description: "Government of Assam"
            },
            {
                name: "World Wildlife Fund",
                logo: WWF,
                description: "Swiss Based International Non Profit Organization"
            },
            {
                name: "Pollution Control Board",
                logo: Pollution,
                description: "Government of India"
            },
            {
                name: "Royal Global University",
                logo: RGU,
                description: "Educational Institute"
            },
            {
                name: "District Tobacco Control Society",
                logo: WLFR,
                description: "Government of Assam"
            }
        ]
    } = props;

    return (
        <div className="collaboration-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="collaboration-content">
                            {/* Section Title */}
                            <div className="collaboration-title">
                                <h2>{title}</h2>
                                <p>{subtitle}</p>
                            </div>

                            {/* Collaboration Grid */}
                            <div className="collaboration-grid">
                                {collaborations.map((collab, index) => (
                                    <CollaborationItem key={index} collab={collab} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Collaboration